

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.infotab');
  const panels = document.querySelectorAll('.infopanel');

  // Safety: Agar kuch galat ho toh bhi first tab/panel active kar do
  if (tabs.length > 0 && panels.length > 0) {
    tabs.forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    panels.forEach(p => p.hidden = true);

    const firstTab = tabs[0];
    const firstPanelId = firstTab.getAttribute('aria-controls');
    const firstPanel = document.getElementById(firstPanelId);

    firstTab.classList.add('active');
    firstTab.setAttribute('aria-selected', 'true');
    if (firstPanel) firstPanel.hidden = false;
  }

  // Click handler
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Sab tabs se active hatao
      tabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      // Sab panels hide karo
      panels.forEach(panel => panel.hidden = true);

      // Clicked tab active karo
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      // Corresponding panel dikhao
      const panelId = tab.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (panel) panel.hidden = false;
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const questions = document.querySelectorAll('.faq-section .question');

  questions.forEach((btn) => {
    btn.addEventListener('click', function() {
      const answer = document.getElementById(this.getAttribute('aria-controls'));
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const icon = this.querySelector('.toggle-icon');

      if (expanded) {
        // Close
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.offsetHeight;
        answer.style.maxHeight = "0px";

        this.setAttribute('aria-expanded', "false");
        icon.textContent = "+";   // 👈 CLOSED = +
      } else {
        // Open
        answer.style.maxHeight = answer.scrollHeight + "px";

        this.setAttribute('aria-expanded', "true");
        icon.textContent = "–";   // 👈 OPEN = –

        answer.addEventListener('transitionend', function handler() {
          if (btn.getAttribute('aria-expanded') === 'true') {
            answer.style.maxHeight = null;
          }
          answer.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function() {
  function initMobileSlider() {
    var slider = document.querySelector('.product-media-slider');
    
    if (!slider) return;

    if (slider.flickityInstance) {
      slider.flickityInstance.destroy();
      delete slider.flickityInstance;
    }

    if (window.innerWidth <= 989 && typeof Flickity !== 'undefined') {
      var flkty = new Flickity(slider, {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true,
        imagesLoaded: true,
        lazyLoad: 2,
        adaptiveHeight: true,
        percentPosition: true,
        setGallerySize: true
      });
      slider.flickityInstance = flkty;
    }
  }

  initMobileSlider();

  // Resize pe bhi re-init ho jaaye
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMobileSlider, 200);
  });
});

  document.querySelectorAll('.video-container').forEach(container => {
          const video = container.querySelector('video, iframe');
          const overlay = container.querySelector('.play-button-overlay');

          if (!video || !overlay) return;

          overlay.addEventListener('click', () => {
            if (video.tagName === 'IFRAME') {
              video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else {
              video.play();
            }
            overlay.classList.add('hidden');
          });

          video.addEventListener('play', () => {
            overlay.classList.add('hidden');
          });

          video.addEventListener('pause', () => {
            overlay.classList.remove('hidden');
          });

          video.addEventListener('ended', () => {
            overlay.classList.remove('hidden');
          });

          if (video.paused || video.ended) {
            overlay.classList.remove('hidden');
          }
        });

        


  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href").substring(1);
        const targetEl = document.getElementById(targetId);

        if (targetEl) {
          e.preventDefault();
          targetEl.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  });


document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.footer-link');
  const popup = document.getElementById('popup');
  const popupTitle = document.getElementById('popup-title');
  const popupText = document.getElementById('popup-text');
  const closeBtn = document.querySelector('.popup-close');

  links.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const linkText = link.textContent;
      const linkHref = link.getAttribute('href');

      popupTitle.textContent = linkText;

      fetch(linkHref)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const footer = doc.querySelector('footer');
          if (footer) {
            footer.remove();
          }

          const body = doc.querySelector('body');
          let content = '';
          if (body) {
            content += `<div class="popup-body">${body.innerHTML}</div>`;
          }

          popupText.innerHTML = content || '<p>Sorry, could not load the content.</p>';
          popup.classList.add('show');
          popup.setAttribute('aria-hidden', 'false');
        })
        .catch(error => {
          popupText.innerHTML = `<p>Failed to load content from the link.</p>`;
          console.error('Error fetching page:', error);
          popup.classList.add('show');
          popup.setAttribute('aria-hidden', 'false');
        });
    });
  });

  closeBtn.addEventListener('click', () => {
    popup.classList.remove('show');
    popup.setAttribute('aria-hidden', 'true');
  });

  window.addEventListener('click', (event) => {
    if (event.target === popup) {
      popup.classList.remove('show');
      popup.setAttribute('aria-hidden', 'true');
    }
  });
});
